import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-icons/font/bootstrap-icons.css';
 import "../Css/LoginForm.css";

const LoginForm = () => {
  const [formData, setFormData] = useState({ uname: '', pass: '', otp: '', validateEmail: '', newPassword: '', confirmPassword: '' });
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpTimer, setOtpTimer] = useState('4:59');
  const [showModal, setShowModal] = useState({ email: false, password: false, updatePassword: false });
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const navigate = useNavigate(); // Use the useNavigate hook
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const sendOtp = () => {
    if (!document.getElementById('chk_d').checked) {
      Swal.fire('Agreement', 'Click Agree to continue', 'warning');
      return;
    }
    
    // Make the API call here
    Swal.fire('Please wait...', 'Sending OTP', 'info');
    
    // On success
    setIsOtpSent(true);
    setShowOtpModal(true);
    
    // Start OTP timer
    let initialTimer = 299; // 4 minutes 59 seconds = 299 seconds
    setOtpTimer(formatTime(initialTimer)); // Initialize timer
  
    const interval = setInterval(() => {
      initialTimer--;
      setOtpTimer(formatTime(initialTimer)); // Update timer every second
      
      if (initialTimer === 0) {
        clearInterval(interval);
        window.location.href = "https://pomsuat.mobilestyx.ca/police_app_peterborough/login"; // Redirect after timer ends
      }
    }, 1000);
  };
  
  // Helper function to format time as MM:SS
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  };

  const verifyOtp = () => {
    // Make the API call here
    Swal.fire('Please Wait...', 'Verify OTP', 'info');
    // On success
    setOtpVerified(true); // Set state to indicate OTP has been verified
    navigate('/Home'); 
  };

  const password_show_hide = (input, eyeIcon) => {
    if (input.type === "password") {
      input.type = "text";
      eyeIcon.classList.remove("fa-eye");
      eyeIcon.classList.add("fa-eye-slash");
    } else {
      input.type = "password";
      eyeIcon.classList.remove("fa-eye-slash");
      eyeIcon.classList.add("fa-eye");
    }
  };

  return (
    <div className="login-bg">
      <div className="row">
        <div className="login-box mt-4 m-auto rounded">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="col text-center">
                  <div className="text-white">
                    You are currently accessing the UAT version of our software.To access the LIVE version. Please contact <a style={{ color: 'white' }} href="/cdn-cgi/l/email-protection#a9dadcd9d9c6dbdde9c4c6cbc0c5ccdaddd0d187cac8"><span className="__cf_email__" data-cfemail="4e3d3b3e3e213c3a0e23212c27222b3d3a3736602d2f">[email&#160;protected]</span></a>
                  </div>
                  <img className="m-3 icon-75" style={{ width: '100px', height: '100%', padding: '8px' }} alt="Poms-logo" src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/png/POMS.png" />
                  <h1 className="text-white" style={{ fontSize: '15px' }}>{showOtpModal ? 'VERIFY OTP' : 'LOGIN'}</h1>
                </div>
                {!showOtpModal ? (
                  <div className="col-12 my-3 p-0">
                    <form id="login_form" autoComplete="off">
                      <div className="form-row justify-content-center flex-column align-items-center">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="form-floating">
                            <input type="text" id="uname" maxLength="15" style={{ textTransform: 'lowercase' }} className="form-control login_text_box" name="uname" placeholder="Uname"  value={formData.uname} onChange={handleChange} />
                            <label htmlFor="Name" className="dark1">Username*</label>
                          </div>
                        </div>
                        <input type="hidden" name="resend_oty_y" id="resend_oty_y" value="N" />
                        <div className="col-md-12 col-sm-12 col-xs-12">
                          <div className="input-group form-floating">
                            <input type="password" id="pass" maxLength="15" style={{ textTransform: 'none' }} className="form-control login_text_box" name="pass" placeholder="pass"  value={formData.pass} onChange={handleChange} />
                            <label htmlFor="Pass" className="dark1">Password*</label>
                            <div className="input-group-append">
                              <span className="input-group-text show_pass" onClick={() => password_show_hide(document.getElementById('pass'), document.getElementById('show_eye'))}><i className="fas fa-eye" id="show_eye"></i></span>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ color: 'white' }}>
                          <input type="checkbox" id="chk_d" name="chk_d" required defaultChecked /> I agree to receive OTP via mail & SMS for authentication purposes.
                        </div>
                      </div>
                     
                       <div className="form-group text-center" id="main_div">
              <button type="button" className="btn btn-danger" id="otp_btn" onClick={sendOtp}>SUBMIT</button>
                        <button type="button" className="btn btn-danger" id="frgt_pass" onClick={() => setShowModal({ ...showModal, email: true })}>FORGOT PASSWORD</button>
            </div>
                    </form>
                  </div>
                ) : (
                  <div className="form-group text-center mx-auto">
                    <div className="input-group">
                      <input type="number" className="form-control login_text_box" id="otp" name="otp" style={{ color: 'white' }} maxLength="6" value={formData.otp} onChange={handleChange} placeholder="Enter OTP" />
                      <p className="w-100" style={{ display: isOtpSent ? 'block' : 'none', color: 'white', marginTop: '10px' }}>
{otpTimer}</p>
                    </div>
                    <p className="w-100" style={{ display: isOtpSent ? 'block' : 'none', color: 'white', marginTop: '10px' }}><span><a id='resend_otp' href="javascript:void(0);" onClick={sendOtp}><small style={{ color: 'white' }}>RESEND OTP</small></a></span></p>
                    <div className="form-group text-center mt-2">
                    <button type="button" className="btn btn-danger" onClick={verifyOtp}>VERIFY OTP</button>

                      <a href="https://pomsuat.mobilestyx.ca/police_app_peterborough/login" className="btn btn-danger">BACK</a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Email Modal */}
      
       <div className={`modal ${showModal.email ? 'show' : ''}`} id="confirm_email_modal" tabIndex="-1" role="dialog" style={{ display: showModal.email ? 'block' : 'none' }}>
        

        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title"><i className='glyphicon glyphicon-envelope text-info'></i>VERIFY EMAIL</h4>
            </div>
            <div className="modal-body">
              <div className="col-sm-offset-4" style={{ textAlign: 'center' }}>
                <div className='form-group'>
                <div className='form-floating col-xs-8'>
                    <input type="text" className="form-control input_card2" style={{ textTransform: 'lowercase' }} name="validateEmail" id="validate_email" placeholder=" " value={formData.validateEmail} onChange={handleChange} />
                    <label htmlFor="validate_email">EMAIL ADDRESS*</label>
                  </div>
                  <div className="modal-footer" style={{ textAlign: 'center' }} >
                  <button className="btn btn-danger fs-10" id="btn_modal_validate" onClick={() => setShowModal({ ...showModal, password: true, email: false })}>SEND OTP</button>
                  <button className="btn btn-danger fs-10" data-dismiss="modal" onClick={() => setShowModal({ ...showModal, email: false })}>CANCEL</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;